// Start Gift Icon
$(document).ready(function() {
  
  setTimeout(
  function() 
  {

if($(window).width() < 988) {
             
$("#menu-drawer > div > div > nav > ul > li:nth-child(1) > a > span.gm-icon.gm-icon-img").html("<img src='https://cdn.shopify.com/s/files/1/0855/3804/6232/files/vtb-20201001-halloween-bat-v2.gif?v=1791395105'>");  
              
 } else if ($(window).width() >= 988) {
  
$("div > header > nav > ul > li:nth-child(1) > a > span.gm-icon.gm-icon-img").html("<img src='https://cdn.shopify.com/s/files/1/0855/3804/6232/files/vtb-20201001-halloween-bat-v2.gif?v=1791395105'>");  
     
  
                                        
    };

     }, 1000);
  });
// End Gift Icon

